import type { TechniqueRuleVersion } from '../rules.js';

/**
 * REGLAS TECNICAS DE REFERENCIA.
 *
 * Son DATOS: viven aqui para que los vectores de prueba y la semilla de la base
 * de datos usen exactamente los mismos valores. En produccion se editan en la
 * tabla `technique_rule_version`, no aqui.
 *
 * Las cifras salen del contrato de cada proceso, no de la intuicion:
 *  - DTF imprime en cuatricromia + blanco: sin limite de tintas, pero exige
 *    resolucion real.
 *  - La serigrafia se produce por tintas planas separadas (DEC-07): cada tinta
 *    es una pantalla, de ahi el limite y el coste por tinta.
 *  - El bordado no reproduce trazos finos ni cuerpos pequenos, y siempre exige
 *    digitalizacion externa (R-7).
 *  - La sublimacion solo tine poliester (o soporte con capa polimerica).
 */

const FROM = '2026-01-01T00:00:00.000Z';

export const DTF_RULE: TechniqueRuleVersion = {
  techniqueId: 'dtf',
  version: '1.0.0',
  validFrom: FROM,
  validUntil: null,
  maxInks: null,
  minEffectiveDpi: 150,
  minStrokeWidthMm: 0.4,
  minTextSizeMm: 4,
  maxAreaMm2: 300 * 400,
  maxLayers: 30,
  // Un `spot` en DTF es legitimo: la conversion a cuatricromia la hace el
  // `output_profile` del proveedor, no el documento (ARQUITECTURA §4).
  allowedColorTypes: ['rgb', 'cmyk', 'spot', 'technical_white'],
  gradientsAllowed: true,
  technicalWhiteAvailable: true,
  requiresExternalDigitizing: false,
  allowedSubstrates: ['algodon', 'poliester', 'mezcla'],
};

export const SCREEN_PRINT_RULE: TechniqueRuleVersion = {
  techniqueId: 'screen_print',
  version: '1.0.0',
  validFrom: FROM,
  validUntil: null,
  maxInks: 4,
  minEffectiveDpi: 300,
  minStrokeWidthMm: 0.5,
  minTextSizeMm: 5,
  maxAreaMm2: 300 * 400,
  maxLayers: 12,
  allowedColorTypes: ['spot', 'technical_white'],
  gradientsAllowed: false,
  technicalWhiteAvailable: true,
  requiresExternalDigitizing: false,
  allowedSubstrates: ['algodon', 'mezcla'],
};

export const EMBROIDERY_RULE: TechniqueRuleVersion = {
  techniqueId: 'embroidery',
  version: '1.0.0',
  validFrom: FROM,
  validUntil: null,
  maxInks: 12,
  minEffectiveDpi: 200,
  minStrokeWidthMm: 1.2,
  minTextSizeMm: 6,
  maxAreaMm2: 200 * 200,
  maxLayers: 8,
  allowedColorTypes: ['spot'],
  gradientsAllowed: false,
  technicalWhiteAvailable: false,
  requiresExternalDigitizing: true,
  allowedSubstrates: ['algodon', 'poliester', 'mezcla', 'loneta'],
};

export const SUBLIMATION_RULE: TechniqueRuleVersion = {
  techniqueId: 'sublimation',
  version: '1.0.0',
  validFrom: FROM,
  validUntil: null,
  maxInks: null,
  minEffectiveDpi: 200,
  minStrokeWidthMm: 0.2,
  minTextSizeMm: 3,
  maxAreaMm2: null,
  maxLayers: 30,
  allowedColorTypes: ['rgb', 'cmyk'],
  gradientsAllowed: true,
  technicalWhiteAvailable: false,
  requiresExternalDigitizing: false,
  allowedSubstrates: ['poliester', 'ceramica'],
};

export const REFERENCE_TECHNIQUE_RULES: TechniqueRuleVersion[] = [
  DTF_RULE,
  SCREEN_PRINT_RULE,
  EMBROIDERY_RULE,
  SUBLIMATION_RULE,
];
